import CloseIcon from '@mui/icons-material/Close';
import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  EditButton,
  EmailField,
  Create,
  SimpleForm,
  TextInput,
  Edit,
  Filter,
  PasswordInput,
  BulkDeleteButton,
  Toolbar,
  SaveButton,
  DeleteButton,
  required,
  email,
  BooleanInput,
  usePermissions,
  useRecordContext,
  useNotify,
  ListButton,
} from 'react-admin';

import { SimpleSearchFilter } from '../../components/SearchInputSimple';
import SelectPermissions from './SelectPermissions';
import ToggleUsuario from './toggleUsuario';

import './style.css';

const UserTitle = () => {
  const record = useRecordContext();
  if (!record) return null;

  return <span>Usuário {record ? `"${record.name}"` : ''}</span>;
};

const UsersFilter = (props) => (
  <SimpleSearchFilter {...props} />
);

const PostBulkActionButtons = ({ permissions, ...props }) => (
  <>
    {!permissions.isLoading &&
      (permissions.permissions.includes('SYS_ADMIN') ||
        permissions.permissions.includes('ROLE_USUARIOS_DELETE')) && (
        <BulkDeleteButton {...props} />
      )}
  </>
);

export const Usuarios = (props) => {
  const permissions = usePermissions();

  return (
    <List title="Usuários" filters={<UsersFilter />} {...props}>
      <Datagrid
        bulkActionButtons={<PostBulkActionButtons permissions={permissions} />}
      >
        <ToggleUsuario label="Ativo" source="disabled" {...props} />
        <TextField label="Nome" source="name" />
        <EmailField label="E-mail" source="email" />
        {!permissions.isLoading &&
          (permissions.permissions.includes('SYS_ADMIN') ||
            permissions.permissions.includes('ROLE_USUARIOS_UPDATE')) && (
            <EditButton />
          )}
      </Datagrid>
    </List>
  );
};

const CustomToolbar = ({ permissions, ...props }) => (
  <Toolbar
    {...props}
    className="botoesUpdate"
    style={{ justifyContent: 'space-between' }}
  >
    <div
      style={{
        width: '250px',
        display: 'flex',
        justifyContent: 'space-between',
      }}
    >
      <SaveButton alwaysEnable />
      <ListButton
        size="medium"
        variant="outlined"
        label="cancelar"
        icon={<CloseIcon />}
      />
    </div>
    {!permissions.isLoading &&
      (permissions.permissions.includes('SYS_ADMIN') ||
        permissions.permissions.includes('ROLE_USUARIOS_DELETE')) && (
        <DeleteButton size="medium" />
      )}
  </Toolbar>
);

export const UserEdit = (props) => {
  const permissions = usePermissions();
  const notify = useNotify();
  const onError = (data) => {
    notify(data.message);
  };

  return (
    <Edit redirect="list" title={<UserTitle />} {...props}>
      <SimpleForm toolbar={<CustomToolbar permissions={permissions} />}>
        <TextInput validate={required()} label="Nome" source="name" />
        <TextInput
          validate={[required(), email()]}
          label="E-mail"
          source="email"
          autoComplete="email"
        />
        <PasswordInput
          label="Senha"
          source="password"
          autoComplete="current-password"
        />
        <SelectPermissions />
        <BooleanInput label="Desabilitado ?" source="disabled" />
      </SimpleForm>
    </Edit>
  );
};

export const UserCreate = (props) => {
  const permissions = usePermissions();
  const notify = useNotify();
  const onError = (data) => {
    notify(data.message);
  };

  return (
    <Create redirect="list" {...props} title="Novo(a) Usuário(a)">
      <SimpleForm toolbar={<CustomToolbar permissions={permissions} />}>
        <TextInput validate={required()} label="Nome" source="name" />
        <TextInput
          validate={[required(), email()]}
          label="E-mail"
          source="email"
          autoComplete="email"
        />
        <PasswordInput
          validate={required()}
          label="Senha"
          source="password"
          autoComplete="new-password"
        />
        <SelectPermissions />
        <BooleanInput label="Desabilitado ?" source="disabled" />
      </SimpleForm>
    </Create>
  );
};

export default Usuarios;
